import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosPut } from 'Redux/axiosHelper'
import { OrganizationResp } from 'types/globalTypes'
import { LeagueFinalResp } from 'types/league/league'
import { LeagueInvitationPayload } from 'types/league/leagueInvitation'

const inviteOrganization = async ({
  payload,
  leagueId,
}: {
  payload: LeagueInvitationPayload
  leagueId: string
}) => {
  const response = await axiosPut(payload, `v1/league/${leagueId}`)
  return response.data
}

export const useInviteOrganization = () => {
  const queryClient = useQueryClient()
  return useMutation(inviteOrganization, {
    onSuccess: (data: OrganizationResp[], variables) => {
      queryClient.setQueryData(
        ['league-by-id', variables.leagueId],
        (oldData: LeagueFinalResp | undefined) => {
          if (!oldData) return undefined
          return {
            ...oldData,
            guestOrganizations: [...oldData.guestOrganizations, ...data],
          }
        },
      )
    },
  })
}

const removeGuestOrg = async ({
  leagueId,
  organizationId,
}: {
  leagueId: string
  organizationId: string
}) => {
  const response = await axiosDelete(`v1/league/guest-organization/${leagueId}/${organizationId}`)
  return response.data
}

export const useRemoveGuestOrganization = () => {
  const queryClient = useQueryClient()
  return useMutation(removeGuestOrg, {
    onSuccess: (_, variables) => {
      queryClient.setQueryData(
        ['league-by-id', variables.leagueId],
        (oldData: LeagueFinalResp | undefined) => {
          if (!oldData) return undefined
          return {
            ...oldData,
            guestOrganizations: oldData.guestOrganizations.filter(
              org => org._id !== variables.organizationId,
            ),
          }
        },
      )
    },
  })
}
